import { render, staticRenderFns } from "./SettingsComponent.vue?vue&type=template&id=26f7489c&scoped=true&"
import script from "./SettingsComponent.vue?vue&type=script&lang=js&"
export * from "./SettingsComponent.vue?vue&type=script&lang=js&"
import style0 from "./SettingsComponent.vue?vue&type=style&index=0&id=26f7489c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f7489c",
  null
  
)

export default component.exports